import { partitionArray } from 'app/utils/array';

import {
  AVAILABLE_BLOCK_SLUGS,
  BLOCK_QUERY_MAP,
  BLOCKS_WITH_PERIOD,
  ENTITIES,
  ENTITY_BLOCKS_CONFIG,
  PERIODS,
  SCOREBOARD_TYPES,
  TABS_CONTENT,
  VIDEOGAMES_FOR_SCOREBOARD
} from './urlParams.config';
import { hasDetailedStats } from './videogameSpecific.config.helper';

const isBlockForEntityType = (entity: Entity | null, blockSlug: string): blockSlug is Block => {
  if (!entity) {
    return false;
  }
  const blocks: Block[] = AVAILABLE_BLOCK_SLUGS[entity];
  return blocks.includes(blockSlug as Block);
};

const isTab = (tab: string): tab is Tab => Object.keys(TABS_CONTENT).includes(tab);

const isEntity = (entity: string): entity is Entity => ENTITIES.includes(entity as Entity);

const isPeriod = (period: string): period is StatPeriod => PERIODS.includes(period as StatPeriod);

const isScoreboardType = (scoreboard: string): scoreboard is ScoreboardType =>
  SCOREBOARD_TYPES.includes(scoreboard as ScoreboardType);

const getSingleAndDuplicatedBlocksToFetch = (blocksToFetch: Block[]): [Block[], Block[]] =>
  partitionArray(blocksToFetch, block => {
    if (BLOCK_QUERY_MAP[block] !== undefined) {
      if (blocksToFetch.includes(BLOCK_QUERY_MAP[block])) {
        return 1;
      }
    }
    return 0;
  });

const getBasicAndDetailedBlocks = (entity: Entity | null, blocks: Block[]) => {
  if (!entity) {
    return [[], []];
  }
  return partitionArray(blocks, block =>
    (ENTITY_BLOCKS_CONFIG[entity].detailed_only_blocks as Block[]).includes(block) ? 1 : 0
  );
};

const getBlocksToDisplay = (
  entity: Entity,
  blocks: Block[],
  videogame: VideogameSlug | null
): Block[] => {
  const withDetailedStats = videogame ? hasDetailedStats(videogame) : false;
  if (withDetailedStats) {
    return blocks;
  }
  const [basicBlocks, detailedBlocks] = getBasicAndDetailedBlocks(entity, blocks);
  if (basicBlocks.length === 0) {
    return detailedBlocks;
  }
  return basicBlocks;
};

const isBlockWithPeriod = (block: Block) => BLOCKS_WITH_PERIOD.includes(block);

const getScoreboardTypeForVideogame = (
  scoreboardType: ScoreboardType | undefined,
  videogame: VideogameSlug
): ScoreboardType | undefined => {
  if (!scoreboardType) {
    return undefined;
  }

  if (VIDEOGAMES_FOR_SCOREBOARD[scoreboardType].length === 0) {
    return scoreboardType;
  }

  return VIDEOGAMES_FOR_SCOREBOARD[scoreboardType].includes(videogame) ? scoreboardType : 'basic';
};

export {
  isBlockForEntityType,
  isTab,
  isEntity,
  isPeriod,
  isScoreboardType,
  getBasicAndDetailedBlocks,
  getBlocksToDisplay,
  isBlockWithPeriod,
  getSingleAndDuplicatedBlocksToFetch,
  getScoreboardTypeForVideogame
};
